<template>
  <div id='editor' class="flex pb-2 pt-2" style='box-sizing:border-box'>
    <div class="grow mx-2">
      <textarea ref='body'
                v-model='body'
                autofocus='true'
                :class="bodyInputClasses"
                @input='validate'
                placeholder='Enter your comment here.'
                type="text" />

        <p v-if='validationError' class="text-red-500 text-xs italic">Enter your comment.</p>
    </div>

    <pbc-button @click='onSave' class="pbc-primary-color">
      <post class="mx-2"/>
      <span class="mr-2">Save</span>
    </pbc-button>

    <fill-loader v-if='isSavingStash'
                  class="pbc-z-level-3 bg-white opacity-75"
      />
    <auth-dialog v-if='promptUserLogin'
                 @close='onCloseAuthDialog'
                 @guest='onGuest'
                  :login-state='loginState'/>

  </div>

</template>
<script>
import { savePostStash } from '@/gql/Queries.js';
import AuthDialog from '@ui/organisms/AuthDialog.vue';
import Post from '@icons/Post.vue';
export default {
  inject: ['api'],
  props: {
    parentId: {
      type: String,
      required: true
    },
    opId: {
      type: String,
      required: true
    },
  },
  mounted() {
    console.log('fokken params', this.$route.params);
    if (this.$route.params.autoPost) {
      this.body = this.$route.params.body;
      this.onSave();
    }

    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editTextPostOpen'
    });

    console.log('will load editor');
    this.$eventbus.emit('editorLoaded');

    document.querySelector("#editor").scrollIntoView(false);
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editTextPostClose'
    });
  },
  data() {
    return {
      body: '',
      validationError: false,
      promptUserLogin: false,
      loginState: '',
      isSavingStash: false
    }
  },
  components:{
    Post,
    AuthDialog
  },
  methods:{
    async onSave(skipLoggedInCheck = false) {
      if (!this.validate()) {
        this.validationError = true;
        return;
      }
      this.validationError = false;

      if (!skipLoggedInCheck) {
        this.$ana.track({
          eventCategory:'engagement',
          eventAction:'attemptPost',
          extra:{type:'text'}
        });
      }

      if (!skipLoggedInCheck && !this.$store.state.loggedIn) {


        this.isSavingStash = true;
        const stash = await this.savePostStash();
        this.isSavingStash = false;

        console.log('stash is', stash.id);
        this.loginState = stash.id;
        this.promptUserLogin = true;
        return;
      }

      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'madePost',
        extra:{type:'text'}
      });
      this.$gtag.event('conversion', {'send_to': 'AW-801440214/QHGnCL_UzskBENaDlP4C'});

      console.log('sigh');
      this.$emit("save", {
        parentId: this.parentId,
        opId: this.opId,
        body: this.body
      });

      this.promptUserLogin = false;

    },
    async savePostStash() {
      const data = await this.$apollo.mutate({
        mutation:savePostStash,
        fetchPolicy:'no-cache',
      });

      const {id,url} = data.data.getSignedPostStashUrl;

      const stashData = {
        type:'text',
        id:this.id,
        title:this.title,
        created:this.created,
        opId:this.opId,
        parentId:this.parentId,
        body:this.body,
      }
      await this.uploadFile(url, JSON.stringify(stashData));

      return {id};

    },
    async uploadFile(signedUrl, file) {
      this.loading = true;
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type':'application/json'
        },
        body: file
      };
      const response = await fetch(signedUrl, options)
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`);
      }
    },
    onGuest() {
      console.log('will guest');
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'continueAnonymous',
        extra:{type:'text'}
      });

      this.promptUserLogin = false;
      this.onSave(true);
    },
    onCloseAuthDialog() {
      this.promptUserLogin = false;
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'closeAuth',
        extra:{type:'text'}
      });

      //this.onSave();
    },
    validate() {
      if (!this.body || this.body === '') {
        this.$refs.body.focus();
        this.validationError = true;
        return false;
      }
      return true;
    },

  },
  computed:{
    bodyInputClasses() {
      const classes = ["pbc-standard-input", "text-xl", "my-1"];
      if (this.validationError) {
        classes.push("border-red-500 border border-2");
      }
      return classes;
    }

  }
}
</script>
